import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { Link } from 'react-router-dom';

const schemaData = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于炮渣漫画网 - 韩国漫画大全',
  description: '炮渣漫画网拥有韩国漫画大全，提供最新热门韩国漫画推荐和无删减韩国漫画排行榜。',
  url: 'http://pepmayans.com/about',
  isPartOf: { '@type': 'WebSite', name: '炮渣漫画网', url: 'http://pepmayans.com/' },
};

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main>
        <div className="px-6 md:px-10 max-w-[1280px] mx-auto pt-24">
          <Breadcrumb items={[
            { label: '首页', to: '/' },
            { label: '关于我们' },
          ]} />
        </div>

        <section className="py-12 md:py-20 bg-background-50">
          <div className="px-6 md:px-10 max-w-[1280px] mx-auto">
            <div className="lg:w-2/3">
              <span className="inline-block text-xs font-medium text-primary-500 bg-primary-50 border border-primary-200/60 px-3 py-1 rounded-full mb-5">
                关于我们
              </span>
              <h1 className="font-heading text-4xl md:text-5xl font-semibold text-foreground-900 leading-tight mb-8">
                炮渣漫画网
                <br />
                您的韩国漫画
                <br />
                专属阅读平台
              </h1>
              <p className="text-foreground-700 leading-relaxed text-sm md:text-base mb-8 max-w-[640px]">
                炮渣漫画网成立于2023年，是一个专注于韩国漫画的内容聚合平台。我们致力于为广大韩漫爱好者提供最新、最全、最高质量的韩国漫画资源。从热门连载到经典完结，从恋爱甜宠到热血战斗，我们收录了超过5000部精选韩国漫画，覆盖数十种类型题材。
              </p>

              <div className="flex flex-col sm:flex-row gap-3 mb-12">
                <a href="#reputation" className="bg-primary-500 hover:bg-primary-600 text-white font-medium px-7 py-3 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors inline-flex items-center justify-center">
                  品牌声誉
                </a>
                <a href="#contact" className="border border-foreground-300 text-foreground-700 hover:border-foreground-500 font-medium px-7 py-3 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors inline-flex items-center justify-center">
                  联系我们
                </a>
              </div>

              <div className="grid grid-cols-2 gap-4 mb-16">
                <img
                  src="https://readdy.ai/api/search-image?query=Creative%20team%20working%20together%20in%20modern%20office%2C%20Korean%20digital%20content%20creation%2C%20warm%20lighting%2C%20collaborative%20atmosphere%2C%20casual%20professional%20setting%2C%20editorial%20photography%20style&width=400&height=300&seq=about-team&orientation=landscape"
                  alt="炮渣漫画团队"
                  className="rounded-xl object-cover w-full h-full"
                />
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20Korean%20tech%20office%20workspace%2C%20digital%20content%20platform%2C%20warm%20natural%20light%2C%20minimalist%20interior%20design%2C%20creative%20environment%2C%20editorial%20photography%20with%20soft%20shadows&width=400&height=300&seq=about-office&orientation=landscape"
                  alt="炮渣漫画办公环境"
                  className="rounded-xl object-cover w-full h-full"
                />
              </div>
            </div>
          </div>
        </section>

        <section id="reputation" className="py-14 md:py-20 bg-background-100">
          <div className="px-6 md:px-10 max-w-[1280px] mx-auto">
            <div className="text-center mb-14">
              <span className="inline-block text-xs font-medium text-accent-600 bg-accent-50 border border-accent-200/60 px-4 py-1.5 rounded-full mb-5">
                品牌声誉
              </span>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
                值得信赖的漫画平台
              </h2>
              <p className="text-foreground-600 text-sm max-w-[520px] mx-auto">
                炮渣漫画网以优质内容和良好体验赢得数百万读者信赖
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { icon: 'ri-award-line', title: '行业认可', desc: '荣获2025年度最佳漫画阅读平台奖项，行业内外一致好评' },
                { icon: 'ri-user-heart-line', title: '用户信赖', desc: '累计服务超过300万活跃读者，用户满意度高达99.7%' },
                { icon: 'ri-shield-star-line', title: '正版授权', desc: '与多家韩国漫画出版社建立合作关系，确保内容合法正版' },
                { icon: 'ri-service-line', title: '优质服务', desc: '7×24小时内容更新保障，专业技术团队维护平台稳定运行' },
              ].map((item, index) => (
                <div key={index} className="group bg-background-50 hover:bg-primary-500 border border-background-200/70 hover:border-primary-500 rounded-xl p-6 transition-all duration-300 cursor-pointer">
                  <div className="w-12 h-12 flex items-center justify-center bg-background-100 group-hover:bg-white/20 rounded-lg mb-5 transition-colors">
                    <i className={`${item.icon} text-xl text-primary-500 group-hover:text-white transition-colors`}></i>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-foreground-900 group-hover:text-white mb-3 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 group-hover:text-white/80 leading-relaxed transition-colors">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="contact" className="relative w-full h-[480px] md:h-[560px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20Korean%20inspired%20backdrop%2C%20soft%20orange%20and%20amber%20gradient%2C%20abstract%20artistic%20composition%20with%20gentle%20light%2C%20dreamy%20ethereal%20mood%2C%20cozy%20atmosphere%2C%20digital%20art%2C%20warm%20sunset%20feel&width=1600&height=900&seq=cta-contact-bg&orientation=landscape"
            alt="联系我们"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6">
            <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white tracking-wide uppercase mb-6">
              联系我们
            </h2>
            <p className="text-white/80 text-sm md:text-lg max-w-[480px] mb-10 leading-relaxed">
              有任何问题或建议？欢迎随时与我们联系
              <br />
              商务合作：hello@pepmayans.com
            </p>
            <Link
              to="/"
              className="group relative inline-flex items-center bg-foreground-950 text-white font-medium text-sm px-8 py-4 rounded-full whitespace-nowrap transition-all hover:bg-foreground-800 cursor-pointer"
            >
              <span className="absolute -left-1 top-1/2 -translate-y-1/2 w-10 h-10 bg-accent-500 rounded-full flex items-center justify-center">
                <i className="ri-mail-line text-white text-sm"></i>
              </span>
              <span className="ml-5">回到首页</span>
              <i className="ri-arrow-right-up-line ml-2 text-sm"></i>
            </Link>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
    </>
  );
}